import styles from './Footer.module.scss';
import {Link, Socials} from "../../components";

export const Footer = () => {
    return (
        <footer className={styles.footer}>
            <div className={styles.info}>
                <div>Cовместный спецпроект телеканала 2x2 и <Link link={`${process.env.REACT_APP_PARTNER_URL}`} text="Звук"/></div>
                <div>Важные ссылки: <Link text="Правила конкурса" link={`${process.env.PUBLIC_URL}/rules.pdf`}/></div>
                <div>Иллюстрации от @poparygina</div>
            </div>
            <div className={styles.wrapper}>
                <div className={styles.desc}>Поделиться КвестУхой</div>
                <Socials share={true} className="footer" footer={true}/>
            </div>
        </footer>
    )
}